import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Scroll from 'react-scroll'
import NProgress from 'react-nprogress'
import axios from 'axios'

import Loader from 'Pods/Shared/Loader'

import ProductAnalyticsTermsModal from './ProductAnalyticsTermsModal'
import ProductAnalyticsTopKeywords from './ProductAnalyticsTopKeywords'
import ProductAnalyticsKeywordSearchContainer from './ProductAnalyticsKeywordSearchContainer'

class ProductAnalyticsMarketplaceStatistics extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      keywords: {
        top: {
          data: {},
          meta: {
            searchParams: {
              page: 1,
              per_page: this.props.tiersData.data.user.currentTier === 1 ? 10 : 100,
              sort_by: ['recommendation', 'desc'],
              keywords_count: 1,
              group: 'categories',
            },
          },
          hidden: true,
          show: 10,
          tableOffset: 0,
          isSorting: false,
        },
        search: {
          data: null,
          hidden: true,
          show: 10,
          value: '',
          tableOffset: 0,
          isSorting: false,
        },
        highlight: {
          value: '',
        },
      },
      moreButtonToggle: true,
      modalIsOpen: false,
      termsModalIsOpen: !this.props.analyticsParticipant,
      initialFetch: true,
      activeSearchGroup: 2,
      axiosSource: axios.CancelToken.source(),
      tierRule: 2,
    }

    this.fetchData = this.fetchData.bind(this)
    this.onFetchSuccess = this.onFetchSuccess.bind(this)
    this.showMoreKeywords = this.showMoreKeywords.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.searchKeyword = this.searchKeyword.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.closeTermsModal = this.closeTermsModal.bind(this)
    this.scopeButtonClassName = this.scopeButtonClassName.bind(this)
    this.handleGroupChange = this.handleGroupChange.bind(this)
    this.wordCountButtonClassName = this.wordCountButtonClassName.bind(this)
    this.handleWordCountChange = this.handleWordCountChange.bind(this)
    this.handleRuleSelection = this.handleRuleSelection.bind(this)
    this.agreeToTerms = this.agreeToTerms.bind(this)
    this.onAgreeToTermsSuccess = this.onAgreeToTermsSuccess.bind(this)
  }

  componentWillMount() {
    this.handleRuleSelection(2)
  }

  componentDidMount() {
    this.fetchData(this.state.keywords.top.meta.searchParams, 'top')
  }

  componentWillUnmount() {
    this.state.axiosSource.cancel('Component Is Unmounting')
  }

  fetchData(filterData, scope, target) {
    this.setState(prevState => ({
      keywords: {
        ...prevState.keywords,
        [scope]: {
          ...prevState.keywords[scope],
          tableOffset: target || 0,
          isSorting: true,
        },
      },
    }))

    NProgress.start()

    return axios.get('/api/internal/keyword-analytics', {
      params: filterData,
      cancelToken: this.state.axiosSource.token,
    })
      .then((response) => this.onFetchSuccess(response, scope, target))
      .catch((error) => {})
  }

  onFetchSuccess(response, scope, target) {
    NProgress.done()

    return this.setState(prevState => ({
      keywords: {
        ...prevState.keywords,
        [scope]: {
          ...prevState.keywords[scope],
          data: response.data.data,
          meta: response.data.meta,
          tableOffset: target || 0,
          isSorting: false,
        },
      },
      initialFetch: false,
    }))
  }

  scopeButtonClassName(scope) {
    if (this.state.keywords.top.meta.searchParams.group === scope) {
      return 'btn btn-secondary'
    }
    return 'btn btn-default'
  }

  wordCountButtonClassName(scope) {
    if (this.state.activeSearchGroup === scope) {
      return 'btn btn-secondary'
    }
    return 'btn btn-default'
  }

  openModal() {
    this.setState({ modalIsOpen: true })
  }

  closeModal() {
    this.setState({ modalIsOpen: false })
  }

  closeTermsModal() {
    this.setState({ termsModalIsOpen: false })
  }

  showMoreKeywords(event) {
    event.preventDefault()

    this.setState(prevState => ({
      moreButtonToggle: !prevState.moreButtonToggle,
      keywords: {
        ...prevState.keywords,
        top: {
          ...prevState.keywords.top,
          hidden: !prevState.keywords.top.hidden,
        },
      },
    }))
  }

  handleGroupChange(key, requiredRuleID) {
    this.handleRuleSelection(requiredRuleID)

    if (this.state.keywords.top.meta.searchParams.group !== key) {
      this.setState(prevState => ({
        keywords: {
          ...prevState.keywords,
          top: {
            ...prevState.keywords.top,
            meta: {
              ...prevState.keywords.top.meta,
              searchParams: {
                ...prevState.keywords.top.meta.searchParams,
                group: key,
              },
            },
          },
        },
      }), () => this.fetchData({
        page: 1,
        per_page: this.props.tiersData.data.user.currentTier === 1 ? 10 : 100,
        sort_by: this.state.keywords.top.meta.searchParams.sort_by,
        keywords_count: 1,
        group: this.state.keywords.top.meta.searchParams.group,
      }, 'top'))
    }
  }

  handleChange(event) {
    this.setState({
      keywords: {
        ...this.state.keywords,
        search: {
          ...this.state.keywords.search,
          value: event.target.value,
        },
      },
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    this.setState(
      { activeSearchGroup: 2 },
      () => this.searchKeyword(this.state.keywords.search.value, this.state.activeSearchGroup)
    )
  }

  handleWordCountChange(key) {
    this.setState(
      { activeSearchGroup: key },
      () => this.searchKeyword(this.state.keywords.search.value, this.state.activeSearchGroup)
    )
  }

  handleRuleSelection(requiredRule) {
    const userTier = this.props.tiersData.data.user.currentTier

    requiredRule = userTier === 0 && requiredRule === 2 ? 1 : requiredRule

    this.setState({
      tierRule: requiredRule,
    })
  }

  searchKeyword(value, count) {
    if (value) {
      this.setState({
        keywords: {
          ...this.state.keywords,
          search: {
            ...this.state.keywords.search,
            value,
          },
          highlight: {
            ...this.state.keywords.highlight,
            value,
          },
        },
        activeSearchGroup: count,
      },
      () => this.fetchData({
        keywords: value,
        per_page: 100,
        sort_by: ['recommendation', 'desc'],
        keywords_count: count,
        group: '',
      }, 'search'))

      setTimeout(() => {
        const stickyNavigationHeight = 55

        Scroll.animateScroll.scrollTo(this.node.offsetTop - stickyNavigationHeight)
      }, 100)
    } else {
      this.setState({
        keywords: {
          ...this.state.keywords,
          search: {
            data: null,
            hidden: true,
            show: 10,
            value: '',
          },
        },
      })
    }
  }

  agreeToTerms() {
    axios.put('/profile/settings/agree-to-product-analytics-participation').then(this.onAgreeToTermsSuccess)
      .catch((error) => {})
  }

  onAgreeToTermsSuccess() {
    this.props.onParticipationAgree()
    this.closeTermsModal()
    window.location.reload()
  }

  render() {
    return (
      <Fragment>
        <ProductAnalyticsTermsModal
          modalIsOpen={this.state.termsModalIsOpen}
          agreeToTerms={this.agreeToTerms}
          closeModal={this.closeTermsModal}
        />

        {this.state.initialFetch ? (
          <div className="card card--flat">
            <Loader />
          </div>
        ) : (
          <div className="card card--flat">
            <div className="l-inner">
              <ProductAnalyticsTopKeywords
                keywords={this.state.keywords.top}
                searchKeyword={this.searchKeyword}
                dataFetch={this.fetchData}
                moreButtonToggle={this.state.moreButtonToggle}
                showMoreKeywords={this.showMoreKeywords}
                scopeButtonClassName={this.scopeButtonClassName}
                handleGroupChange={this.handleGroupChange}
                tiersData={this.props.tiersData}
                tierRule={this.state.tierRule}
                tabSwitch={this.props.tabSwitch}
              />

              <hr className="is-dashed" ref={node => this.node = node} />

              <ProductAnalyticsKeywordSearchContainer
                keywords={this.state.keywords.search}
                searchTerm={this.state.keywords.highlight.value}
                activeSearchGroup={this.state.activeSearchGroup}
                modalIsOpen={this.state.modalIsOpen}
                handleSubmit={this.handleSubmit}
                handleChange={this.handleChange}
                dataFetch={this.fetchData}
                openModal={this.openModal}
                closeModal={this.closeModal}
                wordCountButtonClassName={this.wordCountButtonClassName}
                handleWordCountChange={this.handleWordCountChange}
                tiersData={this.props.tiersData}
                tierRule={this.state.tierRule}
                tabSwitch={this.props.tabSwitch}
              />
            </div>
          </div>
        )}
      </Fragment>
    )
  }
}

ProductAnalyticsMarketplaceStatistics.propTypes = {
  tiersData: PropTypes.object.isRequired,
  tabSwitch: PropTypes.func.isRequired,
  analyticsParticipant: PropTypes.bool.isRequired,
  onParticipationAgree: PropTypes.func.isRequired,
}

export default ProductAnalyticsMarketplaceStatistics
